import { PageRoutePath } from "@app/shared/constants";
import { Configuration, MultilevelNode } from "ng-material-multilevel-menu";

export const reportMap = new Map([
  [PageRoutePath.COUNTRY_LEVEL_OVERVIEW, "b37b4851-b2af-442b-a629-af123b1735e4"],
  [PageRoutePath.SUBREGION_LEVEL_REPORT_KPI, "cbd3f020-0921-408b-83f3-b954e7c2682f"],
  [PageRoutePath.SUBREGION_LEVEL_REPORT_ECONOMY_KPI, "5173162a-3805-4e5a-9fd3-896fe7f85ce4"],
  [PageRoutePath.TERMINAL_LEVEL_REPORT_KPI, "bf6693d0-da1b-4098-b88e-986a8b4fe2ec"],
  [PageRoutePath.TERMINAL_LEVEL_REPORT_ECONOMY_KPI, "265ed7be-91f1-401e-8618-4de7a0f13859"],
  [PageRoutePath.KPI_SUMMARY_REPORT_KPI, "1879b741-11f7-4b37-92f9-161e49df5416"],
  [PageRoutePath.KPI_SUMMARY_REPORT_ECONOMY_KPI, "134eff9b-d584-42a9-a8f1-234bfb4e57ef"],
  [PageRoutePath.DRIVER_PORTRAIT, "d9ae7f43-82da-4b2e-b856-a792880ca0bf"],
  [PageRoutePath.DATA_COMPLETENESS, "ad53b565-8b6a-4dec-b086-18d9acb74a53"],
  [PageRoutePath.ACHIEVEMENT_REPORT, "e2c572e5-5f8f-480c-8434-5e0b72ced459"],
  [PageRoutePath.LEARNEX_REPORT, "0e106d51-f681-4f05-89c4-1cd00ed0bf51"],
]);

export const MenuConfig: Configuration = {
  paddingAtStart: true,
  interfaceWithRoute: true,
  classname: "nav-menu-item",
  listBackgroundColor: "#f9f9f9",
  fontColor: "rgb(8, 54, 71)",
  backgroundColor: "#f9f9f9",
  selectedListFontColor: "#00a8e1",
  highlightOnSelect: true,
  collapseOnSelect: true,
};

export const MenuItems: MultilevelNode[] = [
  {
    label: "ml_151119",
    icon: "home",
    link: "/",
  },
  {
    label: "ml_151039",
    icon: "admin_panel_settings",
    expanded: false,
    items: [
      {
        label: "ml_144073",
        icon: "perm_identity",
        link: PageRoutePath.DRIVER_DATA,
      },
      {
        label: "ml_144105",
        icon: "account_balance",
        link: PageRoutePath.ORG_UNIT,
      },
      {
        label: "ml_144104",
        icon: "manage_accounts",
        link: PageRoutePath.USER_PROFILE,
      },
      {
        label: "ml_144137",
        icon: "fact_check",
        link: PageRoutePath.KPI_WEIGHT,
      },
      {
        label: "ml_147004",
        icon: "analytics",
        expanded: false,
        items: [
          {
            label: "ml_143956",
            link: PageRoutePath.KPI_DRIVING_BEHAVIOR,
            icon: "drive_eta",
          },
          {
            label: "ml_143936",
            link: PageRoutePath.KPI_IT_TOOLS_USAGE,
            icon: "handyman",
          },
          {
            label: "ml_144084",
            link: PageRoutePath.KPI_SAFETY,
            icon: "verified_user",
          },
          {
            label: "ml_143968",
            link: PageRoutePath.KPI_ECONOMY,
            icon: "price_check",
          },
          {
            label: "ml_144006",
            link: PageRoutePath.KPI_OTHERS,
            icon: "summarize",
          },
        ],
      },
      {
        label: "ml_144088",
        icon: "verified",
        link: PageRoutePath.ACHIEVEMENT,
      },
      {
        label: "ml_151028",
        icon: "emoji_events",
        link: PageRoutePath.AWARD,
      },
      {
        label: "ml_144099",
        icon: "link",
        link: PageRoutePath.REPORT_LINK,
      },
      {
        label: "ml_151081",
        icon: "upload_file",
        link: PageRoutePath.BATCH_IMPORT_EXCEL,
      },
    ],
  },
  {
    label: "ml_151040",
    icon: "dashboard",
    expanded: false,
    items: [
      {
        label: "ml_151042",
        icon: "summarize",
        link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.COUNTRY_LEVEL_OVERVIEW,
      },
      {
        label: "ml_151043",
        icon: "article",
        expanded: false,
        items: [
          {
            label: "ml_144038",
            icon: "inventory",
            link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.SUBREGION_LEVEL_REPORT_KPI,
          },
          {
            label: "ml_144004",
            icon: "price_check",
            link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.SUBREGION_LEVEL_REPORT_ECONOMY_KPI,
          },
        ],
      },
      {
        label: "ml_151047",
        icon: "groups_2",
        expanded: false,
        items: [
          {
            label: "ml_144038",
            icon: "inventory",
            link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.TERMINAL_LEVEL_REPORT_KPI,
          },
          {
            label: "ml_144004",
            icon: "price_check",
            link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.TERMINAL_LEVEL_REPORT_ECONOMY_KPI,
          },
        ],
      },
      {
        label: "ml_151048",
        icon: "fact_check",
        expanded: false,
        items: [
          {
            label: "ml_144038",
            link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.KPI_SUMMARY_REPORT_KPI,
            icon: "area_chart",
          },
          {
            label: "ml_144004",
            link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.KPI_SUMMARY_REPORT_ECONOMY_KPI,
            icon: "task",
          },
        ],
      },
      {
        label: "ml_144088",
        icon: "verified",
        link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.ACHIEVEMENT_REPORT,
      },
      {
        label: "ml_151049",
        icon: "school",
        link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.LEARNEX_REPORT,
      },
      {
        label: "ml_151050",
        icon: "folder_shared",
        link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.DRIVER_PORTRAIT,
      },
      {
        label: "ml_151051",
        icon: "source",
        link: PageRoutePath.EXTERNAL_REPORT,
      },
      {
        label: "ml_151195",
        icon: "source",
        link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.DATA_COMPLETENESS,
      },
    ],
  },
  {
    label: "ml_144058",
    icon: "supervisor_account",
    link: PageRoutePath.COACHING,
  },
  {
    label: "ml_144112",
    icon: "drafts",
    link: PageRoutePath.TEAM_MESSAGE,
  },
  {
    label: "ml_153246",
    icon: "power",
    link: PageRoutePath.POWER_APP,
  },
];

export const OthersMenuItem: MultilevelNode = {
  label: "ml_144006",
  link: PageRoutePath.KPI_OTHERS,
  icon: "summarize",
};

export const NotChinaKpiSubregionReportMenuItem: MultilevelNode = {
  label: "ml_151373",
  link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.SUBREGION_LEVEL_REPORT_KPI,
  icon: "inventory",
};

export const NotChinaKpiTerminalReportMenuItem: MultilevelNode = {
  label: "ml_151374",
  link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.TERMINAL_LEVEL_REPORT_KPI,
  icon: "inventory",
};

export const NotChinaKpiSummaryReportMenuItem: MultilevelNode = {
  label: "ml_151048",
  link: PageRoutePath.SUPERVISOR_DASHBOARD + "/" + PageRoutePath.KPI_SUMMARY_REPORT_KPI,
  icon: "inventory",
};
